//const address = "https://clusterfy.herokuapp.com"
//http://localhost:5000
//https://clusterfy.herokuapp.com
//export default address

const prod = {
    url: {
     API_URL: "https://clusterfy.herokuapp.com",
     REDIRECT_URL: 'https://clusterfy.app',
     LOGOUT_URL: 'https://clusterfy.app/sign-up'
    }
   };
   const dev = {
    url: {
     API_URL: "http://localhost:5000",
     REDIRECT_URL: 'http://localhost:3000',
     LOGOUT_URL: 'http://localhost:3000/sign-up'
    }
   };

export const config = process.env.NODE_ENV === 'development' ? dev : prod;